import React, { useEffect, useState, useRef } from "react";
import { getAppendJobEstimate } from "data/contacts/actions";
import SkipTraceModal from "app/components/SkipTraceModal";
import InfoAlert from "app/components/InfoAlert";
import { useDispatch, useSelector } from "react-redux";

const SkipTraceHandler = ({contactIds, startSkipTrace, onProcessed }) => {
  const dispatch = useDispatch();

  const [isStartProcess, setIsStartProcess] = useState(false);
  const prevStartSkipTraceRef = useRef(false);

  useEffect(() => {
    // Only trigger if startSkipTrace changed from false to true
    if (startSkipTrace && !prevStartSkipTraceRef.current) {
      setIsStartProcess(true);
    }
    prevStartSkipTraceRef.current = startSkipTrace;
  }, [contactIds, startSkipTrace]);

  useEffect(() => {
    if (isStartProcess) {
      startProcess(contactIds);
      setIsStartProcess(false);
      // Notify parent that processing is complete
      if (onProcessed) {
        onProcessed();
      }
    }
  }, [isStartProcess, contactIds, onProcessed]);

  const startProcess = (contactIds) => {
    dispatch(
      getAppendJobEstimate({ contactIds, appendMode: "BOTH", reprocessEnabled: false }, ({ response, error }) => {
        if (error) {
          console.error("Error fetching estimate:", error);
          return;
        }
        const { message } = response || {};

        if (message?.includes("There is an existing append job")) {
          dispatch(InfoAlert.open({
            title: "Skip Trace in Progress",
            infoText: "There is a Skip Trace currently in progress. Please try again once it is complete.",
          }));
        } else {
          dispatch(SkipTraceModal.open({
            reprocessEnabled: false,
            contactIds,
          }));
        }
      }),
    );
  }

  return (
    <>
    </>
  );
};

export default SkipTraceHandler;
